import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getDashboardPembayaranStatistik = createAsyncThunk("dashboard/dataPembayaran/statistik", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pembayaran/statistik`);
    return response.data;
});

export const getDashboardPembayaranStatistikGelombang = createAsyncThunk("dashboard/dataPembayaran/statistikGelombang", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pembayaran/statistik_gelombang`);
    return response.data;
});

const initialState = {
    loadingStatistik : false,
    responseStatistik : [],
    loadingStatistikGelombang : false,
    responseStatistikGelombang : []
}

const dashDataPembayaranSlice = createSlice({
    name:"dashDataPembayaranSlice",
    initialState: initialState,
    extraReducers: {
        [getDashboardPembayaranStatistik.pending] : (state, action) => {
            state.loadingStatistik = true;
        },
        [getDashboardPembayaranStatistik.fulfilled] : (state, action) => {
            state.responseStatistik = action.payload;
            state.loadingStatistik = false;
        },
        [getDashboardPembayaranStatistik.rejected] : (state, action) => {
            state.loadingStatistik = false;
        },
        [getDashboardPembayaranStatistikGelombang.pending] : (state, action) => {
            state.loadingStatistikGelombang = true;
        },
        [getDashboardPembayaranStatistikGelombang.fulfilled] : (state, action) => {
            state.responseStatistikGelombang = action.payload;
            state.loadingStatistikGelombang = false;
        },
        [getDashboardPembayaranStatistikGelombang.rejected] : (state, action) => {
            state.loadingStatistikGelombang = false;
        },
    }
})

export const dashDataPembayaranSelector = (state) => state.dashDataPembayaran;
export default dashDataPembayaranSlice.reducer;
